export const sizes = {
    xs: 4,
    s: 8,
    m: 16,
    ml: 24,
    l: 32,
    lx: 48,
    xl: 64,
  };

  export const colors = {
    pr: '#E4002B',
    sc: '#39434E',
    scl: '#505862',
    f1: '#39434e',
    f2: '#697684',
    f3: '#96a1b0',
    f4: '#f8f9fa',
    w: '#fff',
    b: '#000',
    a: '#ff9a2b',
  };
